import React from "react";
import { FaArrowRight } from "react-icons/fa";
import DisplayAmount from "../components/Home/section4/displayAmount";
import Sec4Description from "../components/Home/section4/sec4description";
import { motion, useScroll, useTransform, useInView } from "framer-motion";
import { useRef } from "react";
import TextPanel from "../components/Home/section3/textPanel";
const Home: React.FC = () => {
  // -----------------section4 setting----

  const sec4img = "/home/sec3_Img1.svg"
  const sec4title = "MINERALEX TOKEN STRATEGY";
  const sec4subtitle = "Own a Share of the Future: TOKENIZED Gold & Minerals on BLOCKCHAIN";
  const sec4contexts = [
    "The future of mineral wealth is digital. Mineralex Group is bringing real-world gold and minerals to the blockchain, offering transparent, secure, and decentralized ownership of valuable natural resources. Be part of the next generation of asset-backed investments.",
    "Mineralex Group is revolutionizing mineral ownership by tokenizing real-world assets such as gold and other valuable minerals. Our platform allows anyone, anywhere, to participate in the value appreciation of these assets, creating a secure, transparent, and accessible investment model.",
  ];
  // ------------------section5 setting-------------

  const sec5title_1 = "";
  const sec5subtitle_1 = "The planned Utility Token ";
  const sec5contexts_1 = [
    "The planned Utility Token will support early-stage project development and ecosystem growth with government rights, priority and discounted access to the planned Mineralex planned RWA token. Funds raised are allocated to:",
  ];
  const sec5title_2 = "";
  const sec5subtitle_2 = "Mineralex planned RWA – Real-World Asset Token  ";
  const sec5contexts_2 = [
    "The planned Mineralex RWA token will be directly backed by real mined, stored gold. Its value is supported by:",
  ];
  // ------------------section6 setting-------------

  const sec4imgsize = "75px";
  // -------------------section7 setting---------------
  const sec6title = "Community approach";
  const sec6subtitle = "Together, fair and transparent";
  const sec6contexts = [
    "Mineralex (SL)'s ownership structure is uniquely designed to align the interests of local communities with the company's growth objectives.",
    "Mineralex prioritizes strong relationships with local communities , recognizing that responsible mining includes making a positive, sustainable impact on the regions it operates.",
  ];



  // Refs for in-view detection
  const sec3Ref = useRef(null);
  const sec4Ref = useRef(null);
  const sec6Ref = useRef(null);

  // Scroll progress for Section 1 parallax
  const { scrollYProgress } = useScroll();
  const panelSetupRef = useRef(null);
  const panelSetupInView = useInView(panelSetupRef, { once: false, amount: 0 });

  // In-view hooks
  const sec3InView = useInView(sec4Ref, { once: false, amount: 0 });

  const sec4InView = useInView(sec4Ref, { once: false, amount: 0.2 });
  const sec6InView = useInView(sec6Ref, { once: false, amount: 0.2 });

  // Section 1: Slower parallax
  const textY = useTransform(scrollYProgress, [0, 0.6], [0, 100]);

  // Animation variants
  const sec3ItemVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,

      transition: { duration: 2, type: "spring", bounce: 0.4 },
    },
  };
  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 2, type: "spring", bounce: 0.4 },
    },
  };
  return (
    <div className="w-full flex flex-col items-center justify-center bg-white box-border overflow-hidden z-[5]">

      {/* ------------section1------------- */}
      <div id="home" className="contain w-full min-h-screen  md:h-auto bg-[url('../public/home/section1.svg')]  bg-black/30  bg-blend-overlay  bg-cover bg-center flex flex-col justify-around items-center py-4 lg:py-40 2xl:py-50 transition-all duration-500">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 2, type: "spring", bounce: 0.4 }}
          style={{ y: textY }}
          className="w-full flex flex-col items-center justify-center gap-[33px] mt-36">
          <div className="flex flex-col items-center justify-center gap-[30px] text-center text-[#000000] text-4xl md:text-5xl  2xl:text-[60px] font-bungeeinline font-normal uppercase z-30">
            <div className="text-white">Invest in Verified Mineral Reserves</div>
            <div className="text-[#F8D835]"> Through Blockchain Technology</div>
          </div>
          <div className="wrap-text text-white text-[20px] lg:text-3xl font-montserrat font-[500] text-center leading-[22px] mt-[8px] mb-[18px] z-30">
            Tokenizing Mineral Reserves for Transparency and Global Access
          </div>

          <div className="flex flex-col sm:flex-row gap-4 sm:gap-20">
            <a
              href="/investor_Portal">
              <motion.button
                whileHover={{ scale: 1.15, rotate: 2, transition: { duration: 0.5 } }}
                whileTap={{ scale: 0.85 }}
                className="min-w-[123px] min-h-[32.8px] bg-[#F8D835] font-montserrat text-black text-[14px] px-2 py-1 sm:text-[20px] md:text-[24px] lg:text-[29px] sm:px-10 md:px-15 lg:px-15 lg:py-6 rounded-3xl border-[2px] border-[#F8D835] focus:outline-none shadow-md  hover:bg-[#8a936d80] active:bg-[#babd8a] z-40 truncate">
                <div
                  className="flex flex-row gap-1 justify-center items-center font-bold z-40 uppercase">
                  Investor Portal
                </div>
              </motion.button>
            </a>

            <a
              href="/presale_Token">
              <motion.button
                whileHover={{ scale: 1.15, rotate: 2, transition: { duration: 0.5 } }}
                whileTap={{ scale: 0.85 }}
                className="min-w-[123px] min-h-[32.8px] bg-transparent font-montserrat text-[#F8D835] text-[14px] px-2 py-1 sm:text-[20px] md:text-[24px] sm:px-10 lg:px-15 lg:py-6 rounded-3xl border-[2px] border-[#F8D835] focus:outline-none shadow-md  hover:bg-[#8a936d80] active:bg-[#babd8a] z-40 truncate">
                <div
                  className="flex flex-row justify-around items-center gap-2 font-bold z-40 uppercase">
                  Presale token
                  <FaArrowRight className="text-[#F8D835]" />
                </div>
              </motion.button>
            </a>
          </div>
        </motion.div>

      </div>

      {/* ------------------------------------section2------------------------------------------- */}

      <div id="about" className="contain w-full min-h-screen  bg-[url('../public/home/section2.svg')] bg-cover bg-center  transition-all duration-500">

        <div className="flex-1">
          <motion.div
            ref={panelSetupRef}
            initial="hidden"
            animate={panelSetupInView ? "visible" : "hidden"}
            variants={{
              hidden: { opacity: 0, y: 50 },
              visible: { opacity: 1, y: 0, transition: { duration: 2, type: "spring", bounce: 0 } },
            }}
            className="contain w-full h-auto flex flex-col items-start justify-center gap-6 md:gap-8  p-4 sm:p-10 z-30 relative"
          >
            <div className="border-l-2 border-[#172B6B] px-2 text-[#172B6B] font-bold text-[23px] lg:text-5xl font-bungeeinline">
              About Mineralex
            </div>
            <div className="text-white text-xl lg:text-3xl flex flex-col gap-6 items-start">
              <div><span className="font-bold text-2xl lg:text-4xl">The Mineralex Group Ecosystem </span> is a planned groundbreaking tokenized platform  designed to bridge the gap between real-world mineral resources and the digital economy.
              </div>
              <div>
                Mineralex’s mission is to explore, invest in, and establish high-value mineral resources mines such as large scale Coltan, Rare Earth Elements (REE), and Tin mines but focus primarily on Gold mining which will be securely stored to back Mineralex Token to create stable value and growth.
              </div>
              <div>
                Using two core tokens plan, the <span className="font-bold text-2xl lg:text-4xl">Mineralex Utility Token </span>and the<span className="font-bold text-2xl lg:text-4xl"> Mineralex Real-World Asset</span>  to assets, along with staking incentives and community governance mechanisms.
              </div>
              <div>
                <span className="font-bold text-2xl lg:text-4xl">Mineralex aim</span> to secure mined Gold, securely stored and supervised to back up MXRWA to support token stability and value growth. Mineralex intends to store mined Gold as fast as possible and as much as possible to reduce dramatically token holders risk of Token value decrease.
              </div>
              <div>
                Mineralex also aims to use Income generated from mining and selling of non-gold minerals (Coltan, Tin, REEs) for dividends distribution and constantly promote  <span className="font-bold text-2xl lg:text-4xl"> Mineralex RWA value growth.</span>
              </div>
            </div>



            <div className="w-full">
              <button className="float-right min-w-[123px] min-h-[32.8px] bg-[#172B6B] font-montserrat text-white text-[20px] md:text-[24px] lg:text-[29px] px-6 py-2 md:px-10 my-8 rounded-2xl border-[2px] border-[#F8D835] focus:outline-none shadow-md  hover:bg-[#8a936d80] active:bg-[#babd8a] truncate">
                <a
                  href="/aboutUs"
                  className="flex flex-row gap-1 justify-center items-center font-bold">
                  LEARN MORE
                </a>
              </button>
            </div>
          </motion.div>
        </div>

      </div>
      {/* -----------------------------section3---------------------- */}
      <div id="market_challenges" className="contain w-full min-h-screen  flex flex-col  items-center justify-around px-4 lg:p-10  transition-all duration-500">

        <div className="w-full border-l-4 border-[#172B6B] px-2 text-[#172B6B] font-bold text-[23px] lg:text-5xl font-bungeeinline text-left">
          The Mineral market challenges
        </div>
        <motion.div
          ref={sec3Ref}
          initial="visible"
          animate={sec3InView ? "visible" : "visible"}
          variants={sec3ItemVariants}
          className="w-full  h-full relative">
          <img src="./home/sec3_market_challeges.png" alt="sec3_market_challeges"
            className="w-full max-w-2xl mx-auto  bg-black/0" />

        </motion.div>
        <div className="text-black text-xl lg:text-4xl flex flex-col gap-6 items-start text-center font-semibold">
          Retail investors are excluded from mineral wealth. Meanwhile, demand for physical inflation hedges like gold and strategic minerals like coltan and REEs is rising sharply.
        </div>
      </div>
      {/* -----------------------section4---------------------- */}
      <motion.div id="token_strategy" className="w-full flex flex-col justify-center items-center gap-12 p-4 md:p-8 mb-8 lg:p-10 relative">

        <TextPanel img={sec4img} title={sec4title} subtitle={sec4subtitle} contexts={sec4contexts} />
        <div className="w-full flex flex-col gap-8 justify-center items-center z-0">
          <motion.div
            ref={sec3Ref}
            initial="visible"
            animate={sec3InView ? "visible" : "visible"}
            variants={sec3ItemVariants} className="w-full h-full">
            <img src="./home/sec3tokenStrategy1.svg" alt="sec4_part2" className="w-full max-w-xl mx-auto
            " />
          </motion.div>
        </div>
        <motion.div className="w-full absolute right-12 -bottom-12">
          <a
            href="/tokenization"
            className=" min-w-[123px] min-h-[32.8px] bg-[#F8D835] font-montserrat text-black text-[14px] px-4 py-2 sm:text-[20px] md:text-[24px] sm:px-10 md:px-15 rounded-3xl border-[2px] border-[#F8D835] focus:outline-none shadow-md  hover:bg-[#8a936d80] active:bg-[#babd8a] float-end truncate">
            <div
              className="flex flex-row gap-1 justify-center items-center font-bold">
              LEARN MORE
            </div>
          </a>
        </motion.div>
      </motion.div>


      {/* ------------------------section5----------------------------*/}

      <motion.div id="plannedTokens" className="w-full flex flex-col justify-center items-center p-4 py-8 md:p-8 mb-8 lg:p-10">
        <div
          className="contain w-full h-auto flex flex-col items-start justify-center gap-6 md:gap-8  sm:p-10 z-30 relative"
        >
          <div className="border-l-4 border-[#172B6B] px-2 text-[#172B6B] font-bold text-[23px] lg:text-5xl font-bungeeinline">
            The planned Tokens
          </div>
          <div className="text-black text-xl lg:text-3xl flex flex-col gap-6 items-start">
            Creates a self-sustaining, value-generating loop that backs digital tokens with growing physical assets.
          </div>
        </div>

        <TextPanel title={sec5title_1} subtitle={sec5subtitle_1} contexts={sec5contexts_1} />
        <div className="w-full flex flex-col gap-8 justify-center items-center z-0 ">
          <motion.div
            ref={sec3Ref}
            initial="visible"
            animate={sec3InView ? "visible" : "visible"}
            variants={sec3ItemVariants} className="w-full h-full aspect-[4/3] sm:aspect-auto">
            <img src="./home/sec5_utilityToken_Allocation.png" alt="sec5_utilityToken_Allocation.png" className="w-full h-full max-w-4xl mx-auto" />
          </motion.div>
        </div>

        <TextPanel title={sec5title_2} subtitle={sec5subtitle_2} contexts={sec5contexts_2} />
        <div className="w-full flex flex-col gap-8 justify-center items-center z-0">
          <motion.div
            ref={sec3Ref}
            initial="visible"
            animate={sec3InView ? "visible" : "visible"}
            variants={sec3ItemVariants} className="w-full h-full">
            <img src="./home/sec5_RWAToken.png" alt="sec5_RWAToken.png" className="w-full max-w-xl mx-auto h-auto mt-8" />
          </motion.div>
        </div>
        <motion.div className="w-full">
          <a
            href="/tokenization"
            className=" min-w-[123px] min-h-[32.8px] bg-[#F8D835] font-montserrat text-black text-[14px] px-4 py-2 sm:text-[20px] md:text-[24px] lg:text-[29px] sm:px-10 md:px-15 lg:px-20 lg:py-6 rounded-3xl border-[2px] border-[#F8D835] focus:outline-none shadow-md  hover:bg-[#8a936d80] active:bg-[#babd8a] float-end truncate">
            <div
              className="flex flex-row gap-1 justify-center items-center font-bold">
              LEARN MORE
            </div>
          </a>
        </motion.div>
      </motion.div>

      {/* ---------------------section6 */}
      <div id="exploration" className="w-full flex flex-col justify-center items-center gap-6 bg-[#172B6B]  bg-[url('../public/home/section4.svg')] bg-cover bg-center px-4  py-8  ">
        <div className="w-full border-l-2 border-[#F8D835] px-2 lg:px-4 text-left text-[#F8D835] font-normal text-[24px] md:text-3xl lg:text-5xl font-bungeeinline">
          EXPLORATION HIGHLIGHTS
        </div>

        <div className="contain w-full max-w-7xl h-auto flex flex-col items-center justify-around gap-6 transition-all duration-500">
          <div className="w-full flex flex-col md:flex-row justify-center items-center gap-4 ">
            <div className="w-full flex flex-col justify-between items-start gap-4">
              <DisplayAmount value={{ text: "+$10B", text_color: "#F8D835", font_size: "35px" }} explanation={{ text: "Bedrock Inferred Deposits Value", text_color: "#FFFFFF", font_size: "20px" }} />
              <DisplayAmount value={{ text: "+$20M", text_color: "#F8D835", font_size: "35px" }} explanation={{ text: "Invested in Exploration ", text_color: "#FFFFFF", font_size: "20px" }} />
            </div>

            <div className="w-full grid grid-flow-col grid-rows-4 sm:grid-rows-2 gap-2 py-4">
              <Sec4Description imgsource="./home/sec4_1.svg" imgsize={sec4imgsize} contexts="15,000 samples" fontColor="white" />
              <Sec4Description imgsource="./home/sec4_2.svg" imgsize={sec4imgsize} contexts="190 pits" fontColor="white" />
              <Sec4Description imgsource="./home/sec4_3.svg" imgsize={sec4imgsize} contexts="Ultra Ground Penetrating Radar" fontColor="white" />
              <Sec4Description imgsource="./home/sec4_4.svg" imgsize={sec4imgsize} contexts="15 trenches" fontColor="white" />
              <Sec4Description imgsource="./home/sec4_5.svg" imgsize={sec4imgsize} contexts="High-Resolution Induced Polarization" fontColor="white" />
              <Sec4Description imgsource="./home/sec4_6.svg" imgsize={sec4imgsize} contexts="12 drill holes" fontColor="white" />
              <Sec4Description imgsource="./home/sec4_7.png" imgsize={sec4imgsize} contexts="+30 trial mining" fontColor="white" />
            </div>
          </div>

          <motion.div
            ref={sec4Ref}
            initial="hidden"
            animate={sec4InView ? "visible" : "hidden"}
            variants={itemVariants} className="w-full ">
            <img src="./home/section4_2.svg" alt="sec4_part2" className="w-full max-w-xl mx-auto" />
          </motion.div>
        </div>
        <div className="w-full">
          <motion.button
            whileHover={{
              scale: 1.15,
              rotate: [0, 2, -2, 0], // Rotate left and right
              transition: { duration: 0.5, ease: "easeInOut" },
            }}
            whileTap={{ scale: 0.85 }}
            className="float-right  min-w-[123px] min-h-[32.8px] bg-[#F8D835] font-montserrat text-black text-[14px] px-4 py-2 sm:text-[20px] md:text-[24px] lg:text-[29px] sm:px-10 md:px-15 lg:px-20 lg:py-6 rounded-3xl border-[2px] border-[#F8D835] focus:outline-none shadow-md  hover:bg-[#8a936d80] active:bg-[#babd8a] truncate">
            <a
              href="/exploration"
              className="flex flex-row gap-1 justify-center items-center font-bold">
              LEARN MORE
            </a>
          </motion.button>
        </div>

      </div>
      {/* ------------------------section6--------------------- */}
      <motion.div
        ref={sec6Ref}
        initial="hidden"
        animate={sec6InView ? "visible" : "hidden"}
        variants={{
          hidden: { opacity: 0, y: 100 },
          visible: { opacity: 1, y: 0, transition: { duration: 2.5, type: "spring", bounce: 0.4 } },
        }}
        className="w-full flex flex-col items-center justify-center gap-6 p-6">
        <TextPanel title={sec6title} subtitle={sec6subtitle} contexts={sec6contexts} />
        <div className="w-full max-w-7xl grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <motion.img
            src="./home/sec6_1.png"
            alt="sec6_1"
            initial={{ opacity: 0 }}
            animate={sec6InView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ duration: 1, delay: 0 }}
          />
          <motion.img
            src="./home/sec6_2.png"
            alt="sec6_2"
            initial={{ opacity: 0 }}
            animate={sec6InView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
          />
          <motion.img
            src="./home/sec6_3.png"
            alt="sec6_3"
            initial={{ opacity: 0 }}
            animate={sec6InView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ duration: 1, delay: 0.4 }}
          />
          <motion.img
            src="./home/sec6_4.png"
            alt="sec6_4"
            initial={{ opacity: 0 }}
            animate={sec6InView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ duration: 1, delay: 0.6 }}
          />
          <motion.img
            src="./home/sec6_5.png"
            alt="sec6_5"
            initial={{ opacity: 0 }}
            animate={sec6InView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ duration: 1, delay: 0.8 }}
          />
          <motion.img
            src="./home/sec6_6.png"
            alt="sec6_6"
            initial={{ opacity: 0 }}
            animate={sec6InView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ duration: 1, delay: 1 }}
          />
        </div>

      </motion.div>
    </div >
  );
};
export default Home;
